// @flow

// import configJSON from './config.json'
import configJSON from './travelConfig.json'
import { getValueForPath } from '../Core/FilterFunctions'

import travelDefaultSpecification from './travelDefaultSpecification.json'
import travelDefaultContent from './travelDefaultContent.json'
import travelDefaultTranslations from './travelDefaultTranslations.json'

export default class ConfigLoader {
  getConfig = (key: string): any =>
    getValueForPath(key, 0, configJSON)

  getDefaultSpecification = () => travelDefaultSpecification

  getDefaultContent = () => travelDefaultContent

  getDefaultTranslations = () => travelDefaultTranslations

}

export const config: ConfigLoader = new ConfigLoader()
